// extracted by mini-css-extract-plugin
module.exports = {"SwipeLeftToClose":"bew_a bhs_bk bhs_bl bhs_bo","SwipeLeftToClose--animating":"bew_b"};